import React from "react";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

interface RoundedCheckboxProps extends React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
> {
  size?: "sm" | "md" | "lg" | "xl" | "xxl";
  tickSize?: "sm" | "md" | "lg" | "xl";
}

const RoundedCheckbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  RoundedCheckboxProps
>(({ className, size = "md", tickSize = "md", ...props }, ref) => {
  const sizeClasses = {
    sm: "size-4",
    md: "size-5",
    lg: "size-6",
    xl: "size-7",
    xxl: "size-10",
  };

  const tickSizeClasses = {
    sm: "size-3",
    md: "size-4",
    lg: "size-5",
    xl: "size-6",
  };

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={`peer ${sizeClasses[size]} data-[state=checked]:bg-brand-cyan data-[state=checked]:border-brand-cyan flex shrink-0 cursor-pointer items-center justify-center rounded-full border-2 border-gray-300 shadow transition-colors duration-200 ease-in-out focus-visible:ring-2 focus-visible:ring-cyan-500 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 ${className || ""} `}
      data-testid="rounded-chk"
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center">
        <Check className={`text-white ${tickSizeClasses[tickSize]}`} strokeWidth={3} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});

RoundedCheckbox.displayName = CheckboxPrimitive.Root.displayName;

export default RoundedCheckbox;
